__turbopack_context__.v({
  "cinemaAddress": "rdweMa_cinemaAddress",
  "cinemaFullLink": "rdweMa_cinemaFullLink",
  "cinemaInfo": "rdweMa_cinemaInfo",
  "cinemaItem": "rdweMa_cinemaItem",
  "cinemaLink": "rdweMa_cinemaLink",
  "cinemaLinkText": "rdweMa_cinemaLinkText",
  "cinemaThumb": "rdweMa_cinemaThumb",
  "cinemaThumbWrapper": "rdweMa_cinemaThumbWrapper",
  "cinemaTitle": "rdweMa_cinemaTitle",
});
